import LRUCache from "lru-cache";
import { memoize } from "lodash-es";
// Relocated from `@msys/backend-cache`, which this layer must not depend on. A
// thin `lodash memoize` + `lru-cache` wrapper — both browser-safe.
export function memoizeLru(fn, resolver, cacheOpts) {
    const memoized = memoize(fn, resolver);
    memoized.cache = new LRUCache(cacheOpts);
    return memoized;
}
//# sourceMappingURL=memoizeLru.js.map